import { render, staticRenderFns } from "./SettingsAppearance.vue?vue&type=template&id=741b0f74"
import script from "./SettingsAppearance.vue?vue&type=script&lang=js"
export * from "./SettingsAppearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports